// import image
import roboticsLogo from "../../image/Logo_robotics.svg";
import agentsLogo from "../../image/Logo_agents.svg";
import bannerImg from "../../image/robotics/freepik__expand__8375.png";
import RestaurantsAndCafés1 from "../../image/robotics/store_solution.jpg";
import ElectronicsAndAppliances1 from "../../image/robotics/store-with-many-items-shelves-including-microwave-toaster.jpg";
import BuildingMaterialsAndHardwares1 from "../../image/robotics/customer-hardware-store-does-select-hammer-tool-showcase.png";
import Furniture1 from "../../image/robotics/room-with-couch-table-with-plant-it.jpg";
import Supermarket1 from "../../image/robotics/elderly-woman-shopping-customer-day.jpg";
import HotelsAndConferences1 from "../../image/robotics/guest-hotel-is-ringing-bell-reception.jpg";
import Attractions1 from "../../image/robotics/black-podium-beneath-canopy-bioluminescent-trees.jpg";

// import data
import contentData from "../../data/content/agents/agentsContent.json";
import mobilityContent from "../../data/content/mobility/mobilityContent.json";
import carDoctorBanner from "../../image/mobility/modern-car-futuristic-road.jpg";
import { DataStructure } from "../../types";
import { useDocumentTitle } from "../../functions/useDocumentTitle";
// import components
import { NavTree } from "../navigation/NavLinkPages";
import { MainFrame, Col2ContentFrame, SpacingFrame, Col4ContentFrame, ColAutoFrame } from "../display/Frame";
import {StepsCard2} from "../display/Cards";
import { BannerSection } from "../display/Sections";
import { ImageImport } from "../display/ImageFormat";
import { TextBody, TitleSubtitle, TextBulletList } from "../display/TextFormat";
import { SlideInAnim } from "../tools/Animations";
import { AgentsHero } from "../agents/AgentsHero";
import { AgentsIntroSection } from "../agents/AgentsIntroSection";
import { AgentsProblemSection } from "../agents/AgentsProblemSection";
import { AgentsProductSuiteSection } from "../agents/AgentsProductSuiteSection";
import { AgentsWhyChooseSection } from "../agents/AgentsWhyChooseSection";
import { AgentsPrimaryCta } from "../agents/AgentsPrimaryCta";
import { getLocalized, HealthLang } from "../health/healthTypes";
import { DisplayInfo2Cols } from "../../functions/DisplayInfoFunctions";
import { AgentsCapabilitySections } from "../agents/AgentsCapabilitySections";
import { AgentsVenueOverview } from "../agents/AgentsVenueOverview";
import { AgentsVideoGallery } from "../agents/AgentsVideoGallery";
// import context
import { useLang } from "../Context";

const typedContent : DataStructure = contentData;
const typedMobilityContent: DataStructure = mobilityContent;
const imagePath = "image/robotics/";
const mobilityImagePath = "image/mobility/";

//////////////////////
// LOCAL FUNCTIONS //
/////////////////////
interface BannerProps {
    title: string;
    subtitle: string;
};
function DefaultBanner({ title, subtitle } : BannerProps) {
    return (
        <BannerSection image={bannerImg} title={ title } subtitle={ subtitle } />
    )
};


export default function Agents() {
    const { lang } = useLang();
    const hLang = lang as HealthLang;
    const data = typedContent["Agents"];

    useDocumentTitle(getLocalized(data.pageTitle, hLang));

    return (
        <main className="overflow-x-clip bg-white text-left">
            <AgentsHero data={data.hero} />
            <NavTree />
            <AgentsIntroSection data={data.intro} />
            <AgentsProblemSection data={data.problem} />
            <AgentsProductSuiteSection data={data.productSuite} />
            <AgentsWhyChooseSection data={data.whyChoose} />
            <AgentsPrimaryCta data={data.ctaPrimary} />
        </main>
    );
}

export function RestaurantsAndCafés() {
    const { lang } = useLang();
    const data = typedContent["RestaurantsAndCafés"];
    const section0 = data[0];
    const section1 = data[1];
    const section2 = data[2];
    const section3 = data[3];
    const section4 = data[4];
    const section5 = data[5];
    const section6 = data[6];

    let devSteps = Object.keys(section1["content"]).map((i) => {
            let content = section1["content"][i];
            return (
                <StepsCard2 data={content} />
            )
        });

    return (
        <>
            <BannerSection image={RestaurantsAndCafés1} title={ data["title"][lang] } subtitle={ data["subtitle"][lang] } />
            


            {/* <BannerSection image={pipelineBanner} title={ data["title"][lang] } subtitle={ data["subtitle"][lang] } textPosition="Top" /> */}
            <NavTree />
            <MainFrame>
            <TitleSubtitle title={ section0["title"][lang] } subtitle={ section0["subtitle"][lang] } spacing={30} />
            </MainFrame>

            <MainFrame style={{ backgroundColor: "rgba(248, 249, 250, 1)" }}>
                <SpacingFrame spacing={60}>
                    <TitleSubtitle title={ section1["title"][lang] } />
                    <ColAutoFrame>
                        { devSteps }
                    </ColAutoFrame>
                </SpacingFrame>
            </MainFrame>
            
            
            <DisplayInfo2Cols contentData={section2["content"]} imagePath={imagePath} title={ section2["title"][lang] }  />
            <div style={{ backgroundColor: "rgba(248, 249, 250, 1)"}}>
            <DisplayInfo2Cols contentData={section3["content"]} imagePath={imagePath} title={ section3["title"][lang] }  />
            </div>
            <DisplayInfo2Cols contentData={section4["content"]} imagePath={imagePath} title={ section4["title"][lang] }  />
            <div style={{ backgroundColor: "rgba(248, 249, 250, 1)"}}>
            <DisplayInfo2Cols contentData={section5["content"]} imagePath={imagePath}  />
            </div>
            <DisplayInfo2Cols contentData={section6["content"]} imagePath={imagePath}  />
        </>
    )
};


export function ElectronicsAndAppliances() {
    const { lang } = useLang();
    const data = typedContent["ElectronicsAndAppliances"];
    const section0 = data[0];
    const section1 = data[1];
    const section2 = data[2];
    const section4 = data[4];
    const section5 = data[5];
    const section6 = data[6];


    let devSteps = Object.keys(section1["content"]).map((i) => {
        let content = section1["content"][i];
        return (
            <StepsCard2 data={content} />
        )
    });

    return (
        <>
            <BannerSection image={ElectronicsAndAppliances1} title={ data["title"][lang] } subtitle={ data["subtitle"][lang] } />
            <NavTree />
            <MainFrame>
            <TitleSubtitle title={ section0["title"][lang] } subtitle={ section0["subtitle"][lang] } spacing={30} />
            </MainFrame>

            <MainFrame style={{ backgroundColor: "rgba(248, 249, 250, 1)" }}>
                <SpacingFrame spacing={60}>
                    <TitleSubtitle title={ section1["title"][lang] } />
                    <ColAutoFrame>
                        { devSteps }
                    </ColAutoFrame>
                </SpacingFrame>
            </MainFrame>
            
            
            <DisplayInfo2Cols contentData={section2["content"]} imagePath={imagePath} title={ section2["title"][lang] }  />
            <DisplayInfo2Cols contentData={section4["content"]} imagePath={imagePath}  />
            <div style={{ backgroundColor: "rgba(248, 249, 250, 1)"}}>
            <DisplayInfo2Cols contentData={section5["content"]} imagePath={imagePath}  />
            </div>
            <DisplayInfo2Cols contentData={section6["content"]} imagePath={imagePath}  />
        </>
    )
};


export function BuildingMaterialsAndHardwares() {
    const { lang } = useLang();
    const data = typedContent["BuildingMaterialsAndHardwares"];
    const section0 = data[0];
    const section1 = data[1];
    const section2 = data[2];
    const section6 = data[6];

    let devSteps = Object.keys(section1["content"]).map((i) => {
        let content = section1["content"][i];
        return (
            <StepsCard2 data={content} />
        )
    });


    return (
        <>
            <BannerSection image={BuildingMaterialsAndHardwares1} title={ data["title"][lang] } subtitle={ data["subtitle"][lang] } />
            <NavTree />
            <MainFrame>
            <TitleSubtitle title={ section0["title"][lang] } subtitle={ section0["subtitle"][lang] } spacing={30} />
            </MainFrame>

            <MainFrame style={{ backgroundColor: "rgba(248, 249, 250, 1)" }}>
                <SpacingFrame spacing={60}>
                    <TitleSubtitle title={ section1["title"][lang] } />
                    <ColAutoFrame>
                        { devSteps }
                    </ColAutoFrame>
                </SpacingFrame>
            </MainFrame>
            
            
            <DisplayInfo2Cols contentData={section2["content"]} imagePath={imagePath} title={ section2["title"][lang] }  />
            <DisplayInfo2Cols contentData={section6["content"]} imagePath={imagePath}  />
        </>
    )
};


export function Furniture() {
    const { lang } = useLang();
    const data = typedContent["Furniture"];
    const section0 = data[0];
    const section1 = data[1];
    const section2 = data[2];
    const section5 = data[5];
    const section6 = data[6];


    let devSteps = Object.keys(section1["content"]).map((i) => {
        let content = section1["content"][i];
        return (
            <StepsCard2 data={content} />
        )
    });

    return (
        <>
            <BannerSection image={Furniture1} title={ data["title"][lang] } subtitle={ data["subtitle"][lang] }/>
            <NavTree />
            <MainFrame>
            <TitleSubtitle title={ section0["title"][lang] } subtitle={ section0["subtitle"][lang] } spacing={30} />
            </MainFrame>

            <MainFrame style={{ backgroundColor: "rgba(248, 249, 250, 1)" }}>
                <SpacingFrame spacing={60}>
                    <TitleSubtitle title={ section1["title"][lang] } />
                    <ColAutoFrame>
                        { devSteps }
                    </ColAutoFrame>
                </SpacingFrame>
            </MainFrame>
            
            
            <DisplayInfo2Cols contentData={section2["content"]} imagePath={imagePath} title={ section2["title"][lang] }  />
            <div style={{ backgroundColor: "rgba(248, 249, 250, 1)"}}>
            <DisplayInfo2Cols contentData={section5["content"]} imagePath={imagePath}  />
            </div>
            <DisplayInfo2Cols contentData={section6["content"]} imagePath={imagePath}  />
        </>
    )
};


export function Supermarket() {
    const { lang } = useLang();
    const data = typedContent["Supermarket"];
    const section0 = data[0];
    const section1 = data[1];
    const section2 = data[2];
    const section5 = data[5];
    const section6 = data[6];


    let devSteps = Object.keys(section1["content"]).map((i) => {
        let content = section1["content"][i];
        return (
            <StepsCard2 data={content} />
        )
    });

    return (
        <>
            <BannerSection image={Supermarket1} title={ data["title"][lang] } subtitle={ data["subtitle"][lang] } />
            <NavTree />
            <MainFrame>
            <TitleSubtitle title={ section0["title"][lang] } subtitle={ section0["subtitle"][lang] } spacing={30} />
            </MainFrame>

            <MainFrame style={{ backgroundColor: "rgba(248, 249, 250, 1)" }}>
                <SpacingFrame spacing={60}>
                    <TitleSubtitle title={ section1["title"][lang] } />
                    <ColAutoFrame>
                        { devSteps }
                    </ColAutoFrame>
                </SpacingFrame>
            </MainFrame>
            
            
            <DisplayInfo2Cols contentData={section2["content"]} imagePath={imagePath} title={ section2["title"][lang] }  />
            <DisplayInfo2Cols contentData={section5["content"]} imagePath={imagePath}  />
            <DisplayInfo2Cols contentData={section6["content"]} imagePath={imagePath}  />
        </>
    )
};

export function HotelsAndConferences() {
    const { lang } = useLang();
    const data = typedContent["HotelsAndConferences"];
    const section0 = data[0];
    const section1 = data[1];
    const section2 = data[2];
    const section4 = data[4];
    const section5 = data[5];
    const section6 = data[6];

    let devSteps = Object.keys(section1["content"]).map((i) => {
            let content = section1["content"][i];
            return (
                <StepsCard2 data={content} />
            )
        });

    return (
        <>
            <BannerSection image={HotelsAndConferences1} title={ data["title"][lang] } subtitle={ data["subtitle"][lang] } />
            <NavTree />
            <MainFrame>
            <TitleSubtitle title={ section0["title"][lang] } subtitle={ section0["subtitle"][lang] } spacing={30} />
            </MainFrame>

            <MainFrame style={{ backgroundColor: "rgba(248, 249, 250, 1)" }}>
                <SpacingFrame spacing={60}>
                    <TitleSubtitle title={ section1["title"][lang] } />
                    <ColAutoFrame>
                        { devSteps }
                    </ColAutoFrame>
                </SpacingFrame>
            </MainFrame>
            
            
            <DisplayInfo2Cols contentData={section2["content"]} imagePath={imagePath} title={ section2["title"][lang] }  />
            <DisplayInfo2Cols contentData={section4["content"]} imagePath={imagePath}  />
            <DisplayInfo2Cols contentData={section5["content"]} imagePath={imagePath}  />
            <DisplayInfo2Cols contentData={section6["content"]} imagePath={imagePath}  />
        </>
    )
};

export function AttractionsAndTransportation() {
    const { lang } = useLang();
    const data = typedContent["Attractions & Transportation"];
    const section0 = data[0];
    const section1 = data[1];
    const section2 = data[2];
    const section3 = data[3];
    const section4 = data[4];

    let coreCards = Object.keys(section1["content"]).map((i) => {
        let content = section1["content"][i];
        return (
            <StepsCard2 data={content} key={i} />
        )
    });

    return (
        <>
            <BannerSection image={Attractions1} title={ data["title"][lang] } subtitle={ data["subtitle"][lang] } />
            <NavTree />
            <MainFrame>
                <TitleSubtitle title={ section0["title"][lang] } subtitle={ section0["subtitle"][lang] } spacing={30} />
            </MainFrame>

            <MainFrame style={{ backgroundColor: "rgba(248, 249, 250, 1)" }}>
                <SpacingFrame spacing={60}>
                    <TitleSubtitle title={ section1["title"][lang] } />
                    <Col4ContentFrame>
                        { coreCards }
                    </Col4ContentFrame>
                </SpacingFrame>
            </MainFrame>

            <AgentsCapabilitySections sectionData={section2} imagePath={imagePath} />

            <AgentsVenueOverview sectionData={section3} />

            <MainFrame smallerPadding>
                <SpacingFrame spacing={32}>
                    <AgentsVideoGallery
                        title={section4["videos"]?.["title"]?.[lang]}
                        subtitle={section4["videos"]?.["subtitle"]?.[lang]}
                        items={section4["videos"]?.["items"]}
                    />
                </SpacingFrame>
            </MainFrame>
        </>
    )
};

export function CarDoctor() {
    const { lang } = useLang();
    const data = typedMobilityContent["car-doctor"] as DataStructure;
    const contentData = data["content"] as DataStructure;

    return (
        <>
            <BannerSection
                image={carDoctorBanner}
                title={data["title"][lang]}
                subtitle={data["subtitle"][lang]}
            />
            <NavTree />
            <DisplayInfo2Cols
                contentData={contentData}
                imagePath={mobilityImagePath}
            />
        </>
    );
}

export function Adam() {
    const { lang } = useLang();
    const data = typedContent["adam"];
    const contentData = data["content"];

    return (
        <>
            <DefaultBanner title={ data["title"][lang] } subtitle={ data["subtitle"][lang] } />
            <NavTree />

            <DisplayInfo2Cols contentData={contentData} imagePath={imagePath} />
        </>
    )
};

export { Aiia, AiiaBrochurePDF } from "./Robotics";